module.exports = __webpack_public_path__ + "media/images/flags/VG-deade697fef097f81741159ad12e45bf.svg";